<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed, provide } from 'vue'
import { cn } from '../utils'
import { AttachmentKey, useAttachmentsContext } from './context'
import type { AttachmentData } from './types'
import { getMediaCategory } from './utils'

interface Props {
  class?: HTMLAttributes['class']
  data: AttachmentData
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()

const { variant } = useAttachmentsContext()
const data = computed(() => props.data)
const mediaCategory = computed(() => getMediaCategory(props.data))

function handleRemove() {
  emit('remove')
}

provide(AttachmentKey, {
  data,
  mediaCategory,
  remove: handleRemove,
  variant,
})
</script>

<template>
  <div
    :class="
      cn(
        'group relative',
        variant === 'grid' && 'size-24 overflow-hidden rounded-lg',
        variant === 'inline' && [
          'flex h-8 cursor-pointer select-none items-center gap-1.5',
          'rounded-md border border-gray-200 px-1.5',
          'text-sm font-medium transition-all',
          'hover:bg-gray-100 hover:text-gray-900',
          'dark:border-white/10 dark:hover:bg-white/10 dark:hover:text-white',
        ],
        variant === 'list' && [
          'flex w-full items-center gap-3 rounded-lg border border-gray-200 p-3',
          'hover:bg-gray-50 dark:border-white/10 dark:hover:bg-white/10',
        ],
        props.class
      )
    "
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
